import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { I18nProvider } from "@lingui/react";
import { App } from "./App.js";
import { AuthProvider } from "./auth.js";
import { i18n } from "./i18n.js";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
  </React.StrictMode>,
);
